import { parseErrors, prepareError } from './validationError';

var DEFAULTS = {
    apiRoot: '',
    mutateResponse: null,
    mutateError: null,
    mutateRawResponse: null,
    headers: null,
    cookies: null,

    parseErrors: parseErrors,
    prepareError: prepareError,

    statusSuccess: [200, 201, 204],
    statusValidationError: [400],

    defaultAcceptHeader: 'application/json'
};

export default DEFAULTS;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/constants.js
// module id = 523
// module chunks = 0